var ButtonGroupWidget = (function () {
    function ButtonGroupWidget() {
    }
    Object.defineProperty(ButtonGroupWidget.prototype, "buttons", {
        get: function () {
            return this.button.buttons;
        },
        enumerable: true,
        configurable: true
    });
    return ButtonGroupWidget;
}());
export { ButtonGroupWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/buttongroup.widget.ts.pre-build-optimizer.js